import { actions as modalActions } from '@saucelabs/sl-container-modal';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import * as actions from './actions';
import * as selectors from './selectors';
import { actions as organizationActions } from './../organization';
import {
  actions as activityActions,
  utils as activityUtils,
} from './../activity';
import { CHARTS_DATA_PERIOD, CHARTS_NUMBER_OF_PERIODS } from './../activity/constants';
import { name as removeTeamFromGroupModalName } from './components/RemoveTeamsFromGroupModal';
import { name as setGroupConcurrencyModalName } from './components/SetGroupConcurrencyModal';

export const initializeOrganizationSettings = () => (dispatch, getState) => {
  const state = getState();
  const { loading } = selectors.groupsEnabledSelector(state);
  const { user: { organization: { id } } } = state;

  if (loading) {
    return dispatch(organizationActions.getOrganization({ organizationId: id }));
  }

  return Promise.resolve();
};

export const initialize = (groupId) => (dispatch) => (
  dispatch(actions.getGroup(groupId))
    .then(() => {
      dispatch(activityActions.getGroupsActivity({
        groupIds: groupId,
        since: activityUtils.xDaysAgo(CHARTS_DATA_PERIOD * CHARTS_NUMBER_OF_PERIODS + 1),
      }));
      dispatch(actions.initialize());
    })
);

export const updateGroup = (group) => (dispatch) => (
  dispatch(actions.updateGroup(group))
    .then(Promise.all([
      dispatch(notificationActions.notifySuccess('Group updated')),
    ]))
);

export const showRemoveTeamFromGroupModal = () => (dispatch) => (
  dispatch(modalActions.showModal(removeTeamFromGroupModalName))
);

export const showSetConcurrencyModal = () => (dispatch) => (
  dispatch(modalActions.showModal(setGroupConcurrencyModalName))
);

export const setGroupConcurrency = (groupId, data) => (dispatch) => (
  dispatch(actions.setGroupConcurrency({ groupId, ...data }))
    .then(() => dispatch(notificationActions.notifySuccess('Concurrency has been set for all teams belonging to the group')))
    .catch(() => dispatch(notificationActions.notifyDanger('Unable to set concurrency for teams')))
);

export const removeTeamsFromGroup = (groupId, selectedTeams) => (dispatch, getState) => {
  const { teams } = selectors.teamsSelector(getState());

  const removeActions = selectedTeams.map((teamId) => (
    actions.removeTeamFromGroup({ groupId, teamId })
  ));

  const dispatchedActions = removeActions.map((action) => (
    dispatch(action).catch(({ teamId }) => {
      const teamName = teams.find(({ id }) => id === teamId).name;
      dispatch(notificationActions.notifyDanger(`Unable to remove team ${teamName}`));
    })
  ));

  return Promise.all(dispatchedActions)
    .then((responses) => {
      const teamNames = responses
        .filter((response) => response)
        .map((response) => teams.find((team) => team.id === response.teamId).name);

      const teamWord = teamNames.length === 1 ? 'team' : 'teams';

      if (teamNames.length) {
        return dispatch(notificationActions.notifySuccess(`Successfully removed ${teamWord} ${teamNames.join(', ')}`));
      }

      return Promise.resolve();
    });
};
